export const CREATE_EXPENSE_TYPE = 'CREATE_EXPENSE_TYPE';
export const EDIT_EXPENSE_TYPE = 'EDIT_EXPENSE_TYPE';
export const SHOW_EXPENSE_TYPE = 'SHOW_EXPENSE_TYPE';
export const EXPENSE_TYPE_SUCCESS = 'EXPENSE_TYPE_SUCCESS';
export const EXPENSE_TYPE_ERROR = 'EXPENSE_TYPE_ERROR';

